import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// Importante: Asegúrate de tener instalados los paquetes necesarios:
// npm install @mui/x-date-pickers @mui/x-date-pickers/AdapterMoment moment

// TimePicker reutilizable optimizado
const TimePickerField = React.memo(({
    id,
    label,
    value,
    onChange,
    disabled = false,
    fullWidth = true,
    size = 'medium'
}) => (
    <LocalizationProvider dateAdapter={AdapterMoment}>
        <TimePicker
            id={id}
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            ampm={false}
            minutesStep={1}
            timeSteps={{ hours: 1, minutes: 1 }}
            slotProps={{
                desktopPaper: {
                    sx: {
                        '& .MuiMultiSectionDigitalClockSection-root, & .MuiDigitalClock-root': {
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                            '&::-webkit-scrollbar': {
                                display: 'none'
                            }
                        }
                    }
                },
                mobilePaper: {
                    sx: {
                        '& .MuiMultiSectionDigitalClockSection-root, & .MuiDigitalClock-root': {
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                            '&::-webkit-scrollbar': {
                                display: 'none'
                            }
                        }
                    }
                }
            }}
            size={size}
            sx={{ minWidth: fullWidth ? '100%' : 'auto' }}
        />
    </LocalizationProvider>
));

TimePickerField.displayName = 'TimePickerField';
export default TimePickerField;